module.exports = __webpack_public_path__ + "img/culture_active2.ddbc0bfa.png";